import React from 'react';
import HGLogin from './HGLogin';
import HGSignUp from './HGSignUp';
import { Card } from '../shadcn/ui/card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../shadcn/ui/tabs';
import { useAppController } from 'context';
import HGFooter from 'components/HGFooter';
import LogoDark from 'assets/images/homegrid-logo-white.png';
import LogoLight from 'assets/images/HomeGrid-logo.png';

const HGAuthenticator = () => {
    const { darkMode } = useAppController()[0];

    return (
        <div className="flex h-screen flex-col items-center justify-start p-5 sm:justify-center">
            <div className="mb-3 px-2 sm:w-[400px]">
                <img
                    src={darkMode ? LogoDark : LogoLight}
                    alt="Brand"
                    className="w-full"
                />
            </div>
            <Card className="w-full p-5 shadow-lg sm:w-[400px] sm:p-8">
                <Tabs defaultValue="login">
                    <TabsList className="mb-8 grid w-full grid-cols-2">
                        <TabsTrigger value="login">Login</TabsTrigger>
                        <TabsTrigger value="signup">Sign Up</TabsTrigger>
                    </TabsList>
                    <TabsContent value="login">
                        <HGLogin />
                    </TabsContent>
                    <TabsContent value="signup">
                        <HGSignUp />
                    </TabsContent>
                </Tabs>
            </Card>
            <div className="sm:w-[400px]">
                <HGFooter />
            </div>
        </div>
    );
};

export default HGAuthenticator;
